//（YELLoopカスタマーサポート)
export const DEFAULT_MAIL_TO = 'YELLoopカスタマーサポート<customer@yelloop.jp>'
